import { InfoIcon as InfoIconBase } from "@packages/ds";
import styled from "styled-components";

export const Container = styled.section`
  margin-top: 24px;
  padding: 32px;
  background-color: var(--section-snow-background-color, var(--snow));
`;

export const InfoIcon = styled(InfoIconBase)`
  color: var(--icon-granite-color, var(--granite));
`;

export const EnvironmentTypesTable = styled.section`
  display: flex;
  flex-direction: column;
`;

export const EnvironmentTableHeaders = styled.div`
  display: flex;
  padding-bottom: 8px;
  border-bottom: 1px solid;
  border-color: var(--section-stone-border-color, var(--stone));
`;

export const EnvironmentTableHeader = styled.div`
  width: ${(props: { width: string }) => props.width};
`;

export const EnvironmentPermissionsWrapper = styled.div`
  display: flex;
  alignitems: center;
  margin: 24px 0;
`;
